export const FETCH_COLOCATION_IS_COMPLETE = 'FETCH_COLOCATION_IS_COMPLETE';

export const FETCH_COLOCATION_IS_PENDING = 'FETCH_COLOCATION_IS_PENDING';

export const FETCH_COLOCATION_IS_ERROR = 'FETCH_COLOCATION_IS_ERROR';

export const FETCH_COLOCATION_BY_ID = 'FETCH_COLOCATION_BY_ID';

export const FETCH_COLOCATION_BY_ID_IS_PENDING = 'FETCH_COLOCATION_BY_ID_IS_PENDING';

export const FETCH_COLOCATION_BY_ID_IS_ERROR = 'FETCH_COLOCATION_BY_ID_IS_ERROR';

export const FETCH_COLOCATION_PDU_BY_ID = 'FETCH_COLOCATION_PDU_BY_ID';

export const FETCH_COLOCATION_PDU_BY_ID_IS_PENDING = 'FETCH_COLOCATION_BY_PDU_ID_IS_PENDING';

export const FETCH_COLOCATION_PDU_BY_ID_IS_ERROR = 'FETCH_COLOCATION_BY_PDU_ID_IS_ERROR';

export const UPDATE_COLOCATION = 'UPDATE_COLOCATION';

export const UPDATE_COLOCATION_IS_PENDING = 'UPDATE_COLOCATION_IS_PENDING';

export const UPDATE_COLOCATION_IS_ERROR = 'UPDATE_COLOCATION_IS_ERROR';

export const SET_RDNS = 'SET_RDNS';

export const SET_RDNS_IS_PENDING = 'SET_RDNS_IS_PENDING';

export const SET_RDNS_IS_ERROR = 'SET_RDNS_IS_ERROR';

export const CANCEL_COLOCATION = 'CANCEL_COLOCATION';

export const CANCEL_COLOCATION_IS_PENDING = 'CANCEL_COLOCATION_IS_PENDING';

export const CANCEL_COLOCATION_IS_ERROR = 'CANCEL_COLOCATION_IS_ERROR';

export const REVERT_CANCEL_COLOCATION = 'REVERT_CANCEL_COLOCATION';

export const REVERT_CANCEL_COLOCATION_IS_PENDING = 'REVERT_CANCEL_COLOCATION_IS_PENDING';

export const REVERT_CANCEL_COLOCATION_IS_ERROR = 'REVERT_CANCEL_COLOCATION_IS_ERROR';

export const FETCH_INVOICES = 'FETCH_INVOICES_COLO';

export const FETCH_INVOICES_IS_PENDING = 'FETCH_INVOICES_COLO_IS_PENDING';

export const FETCH_INVOICES_IS_ERROR = 'FETCH_INVOICES_COLO_IS_ERROR';

export const FETCH_ALERTS = 'FETCH_ALERTS_COLO';

export const FETCH_ALERTS_IS_PENDING = 'FETCH_ALERTS_COLO_IS_PENDING';

export const FETCH_ALERTS_IS_ERROR = 'FETCH_ALERTS_COLO_IS_ERROR';

export const CREATE_ALERTS = 'CREATE_ALERTS_COLO';

export const CREATE_ALERTS_IS_PENDING = 'CREATE_ALERTS__IS_PENDING';

export const CREATE_ALERTS_IS_ERROR = 'CREATE_ALERTS_COLO_IS_ERROR';

export const EDIT_ALERTS = 'EDIT_ALERTS_COLO';

export const EDIT_ALERTS_IS_PENDING = 'EDIT_ALERTS_COLO_IS_PENDING';

export const EDIT_ALERTS_IS_ERROR = 'EDIT_ALERTS_COLO_IS_ERROR';

export const DELETE_ALERTS = 'DELETE_ALERTS_COLO';

export const DELETE_ALERTS_IS_PENDING = 'DELETE_ALERTS_COLO_IS_PENDING';

export const DELETE_ALERTS_IS_ERROR = 'DELETE_ALERTS_COLO_IS_ERROR';

export const FETCH_COLOCATION_UPLINK_BY_ID = 'FETCH_COLOCATION_UPLINK_BY_ID';

export const FETCH_COLOCATION_UPLINK_BY_ID_IS_PENDING = 'FETCH_COLOCATION_BY_UPLINK_ID_IS_PENDING';

export const FETCH_COLOCATION_UPLINK_BY_ID_IS_ERROR = 'FETCH_COLOCATION_BY_UPLINK_ID_IS_ERROR';

export const SORT = 'SORT_COLOCATION';
